import { useState, useEffect, useCallback } from 'react';
import api from '../services/api';

const ONBOARDING_KEY = '@mybank:onboarding-complete';

export const useOnboarding = () => {
  const [isComplete, setIsComplete] = useState(() => {
    return localStorage.getItem(ONBOARDING_KEY) === 'true';
  });

  // Sync with backend on mount
  useEffect(() => {
    const syncWithBackend = async () => {
      try {
        const data = await api.get('/onboarding/status');
        if (data.completed) {
          localStorage.setItem(ONBOARDING_KEY, 'true');
          setIsComplete(true);
        }
      } catch {
        // Silently fail - localStorage remains the source of truth
      }
    };

    const token = localStorage.getItem('@mybank:token');
    if (token) {
      syncWithBackend();
    }
  }, []);

  const completeOnboarding = useCallback(async () => {
    localStorage.setItem(ONBOARDING_KEY, 'true');
    setIsComplete(true);

    try {
      await api.post('/onboarding/complete');
    } catch {
      // localStorage already set, backend will sync later
    }
  }, []);

  const skipOnboarding = useCallback(async () => {
    localStorage.setItem(ONBOARDING_KEY, 'true');
    setIsComplete(true);

    try {
      await api.post('/onboarding/skip');
    } catch {
      // localStorage already set, backend will sync later
    }
  }, []);

  const updateStep = useCallback(async (step) => {
    try {
      await api.put('/onboarding/step', { step });
    } catch {
      // Non-critical, step tracking is best-effort
    }
  }, []);

  const resetOnboarding = useCallback(() => {
    localStorage.removeItem(ONBOARDING_KEY);
    setIsComplete(false);
  }, []);

  return { isComplete, completeOnboarding, skipOnboarding, updateStep, resetOnboarding };
};

export default useOnboarding;
